import React from "react";
// Common Components
import OrderBookTable from "src/Tables/Order/OrderBookTable";
// Local Components
// Hooks
import useRequest from "src/Hooks/useRequest";
// Requests
import { getSynthaticOrderbooks } from "src/Requests/synthetic";
// Types
import {
  ISelectedTableInfo,
  GetBookOrderResponse,
} from "src/Interfaces/Synthetic";

interface IProps {
  selectedTableInfo: ISelectedTableInfo | null;
}

const Orderbook: React.FC<IProps> = ({ selectedTableInfo }) => {
  const orderBookRequest = useRequest(
    () =>
      getSynthaticOrderbooks({
        insIds: selectedTableInfo?.insIds || [],
      }),

    () => {},
  );

  React.useEffect(() => {
    if (!selectedTableInfo) return;
    orderBookRequest.fetchData();
    const interval = setInterval(() => {
      orderBookRequest.fetchData();
    }, 10000);

    return () => clearInterval(interval);
  }, [selectedTableInfo]);

  const getOrderbookValues = (
    values?: GetBookOrderResponse[],
  ): GetBookOrderResponse[] => {
    if (!values || !values.length) return new Array(4).fill(null as any);

    if (values.length < 4) {
      const res: GetBookOrderResponse[] = [...values];
      for (let index = 0; index < 4 - values.length; index++) {
        res.push(null as any);
      }
      return res;
    }
    return values;
  };

  return (
    <div className="flex flex-row justify-start items-end pt-5">
      {getOrderbookValues(orderBookRequest?.response)?.map((resp: any) => (
        <div className="mx-0.5">
          <OrderBookTable tableInfo={resp} />
        </div>
      ))}
    </div>
  );
};

export default Orderbook;
